abstract class ISignInConfigurationDAO {
  public abstract getSignInConfiguration(eventId: number, accountId: number): Promise<ISignInConfigurationDTO>;

  public abstract updateSignInConfiguration(
    accountId: number,
    eventId: number,
    signInConfiguration: ISignInConfigurationDTO
  ): Promise<ISignInConfigurationDTO>;

}

interface ISignInConfigurationDTO {
  requestAccessCodeAutoSingInEnabled: boolean;
  requestAccessCodeRegistrationApprovalEnabled: boolean;
  isButtonAccessCodeSignInEnabled: boolean;
  isButtonAccessCodeRequestEnabled: boolean;
  header?: string;
  instructions?: string;
  requestedMessage?: string;
  requestButtonText: string;
  navigationButtonText: string;
  loginErrorMessage: string;
  loginInstructions: string;
  signInPageLabel: string;
  signInButtonLabel: string;
  requestButtonLabel: string;
}

export {
  ISignInConfigurationDAO,
  ISignInConfigurationDTO
};
